/*@ngInject*/
const YesNoFilterController = function ($scope, coreConstant, advancedFilterModel, localization) {

    this.$onInit = function () {
        this.tooltip = {
            delay: 750
        };

        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.tooltip.message = translations.removeButtonTooltip;
        });

        if (this.criterionTemplate.value !== '0') {
            this.criterionTemplate.value = '0';
            $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
        }
        this.isOpen = true;
    };

    this.handleRemove = function () {
        advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };
};

angular.module('umCore')
    .controller('yesNoFilterController', YesNoFilterController);
